// Interactive product tour. Steps reflect the new polygon-first flow:
// 1) draw or pick an area, 2) tiles appear grouped by year/category, 3) select & order.
// Steps whose target is missing at the moment are auto-skipped so the tour stays useful
// regardless of whether the user already has a polygon on the map.
class Walkthrough {
  constructor() {
    this.steps = [
      {
        target: '.js-nlc-maps-map',
        title: 'Nakreslite polygón',
        text:
          'Kliknite kdekoľvek do mapy a klikajte ďalšie body okolo požadovanej oblasti. Polygón uzavrite dvojklikom alebo kliknutím na prvý červený bod. Ak chcete kreslenie zrušiť, stlačte ESC.',
        position: 'left',
      },
      {
        target: '.js-nlc-maps-area-filter-toggle',
        title: 'Alebo vyberte oblasť',
        text:
          'Nemusíte kresliť ručne. Otvorte filter oblastí a kliknite na kraj, okres alebo obec — systém polygón vytvorí z hraníc tej oblasti.',
        position: 'bottom',
      },
      {
        target: '.js-nlc-maps-area-search',
        title: 'Vyhľadávanie oblasti',
        text:
          'V paneli filtra môžete oblasti vyhľadať písaním názvu. Stlačením Enter sa vyberie prvý výsledok.',
        position: 'bottom',
        beforeShow: () => {
          const content = document.querySelector('.js-nlc-maps-area-filter-content');
          if (content && content.style.display === 'none') {
            const toggle = document.querySelector('.js-nlc-maps-area-filter-toggle');
            if (toggle) toggle.click();
          }
        },
        waitFor: '.js-nlc-maps-area-search',
        waitTimeout: 3000,
      },
      {
        target: '.js-nlc-maps-tabs',
        title: 'Dlaždice pre vašu oblasť',
        text:
          'Hneď ako máte polygón, v ľavom paneli sa zobrazia dostupné dlaždice — zoskupené podľa roku a kategórie. Pri veľkom polygóne sa zvyšok donačíta na pozadí.',
        position: 'right',
      },
      {
        target: '.js-nlc-maps-group-checkbox',
        title: 'Hromadný výber',
        text:
          'Checkbox vedľa roku vyberie všetky dlaždice toho roku. Checkbox pri kategórii vyberie iba dlaždice v rámci nej. Klik na riadok (mimo checkboxu) zložku rozbalí alebo zbalí.',
        position: 'left',
      },
      {
        target: '.js-nlc-maps-checkbox',
        title: 'Výber dlaždice',
        text:
          'Zaškrtnutím checkboxu pridáte dlaždicu do objednávky a zároveň sa jej hranice zobrazia na mape ako prerušovaná modrá linka. Odškrtnutím ju z mapy aj z objednávky odstránite.',
        position: 'right',
      },
      {
        target: '.js-nlc-maps-select-visible',
        title: 'Vybrať všetko zobrazené',
        text:
          'Tlačidlom Vybrať všetko zobrazené naraz označíte všetky dlaždice z aktuálneho zoznamu (rešpektuje aj filter hľadania). Opätovný klik všetky odznačí.',
        position: 'bottom',
      },
      {
        target: '.js-nlc-maps-polygon-from-selection',
        title: 'Polygón zo zvolených dlaždíc',
        text:
          'Týmto tlačidlom prekreslíte polygón tak, aby presne obkľučoval všetky vybrané dlaždice — užitočné keď chcete kúpiť len pár konkrétnych dlaždíc a polygón to má presne reflektovať.',
        position: 'bottom',
      },
      {
        target: '.js-nlc-maps-product-search',
        title: 'Filter dlaždíc podľa názvu',
        text:
          'Keď máte načítaných veľa dlaždíc, môžete ich rýchlo prefiltrovať písaním názvu (napr. „Zvolen").',
        position: 'bottom',
      },
      {
        target: '.js-nlc-maps-selection',
        title: 'Panel vybraných',
        text:
          'Tu vidíte všetky vybrané dlaždice. Klikom na × pri názve ich rýchlo odoberiete — bez nutnosti scrollovať späť do zoznamu.',
        position: 'bottom',
        beforeShow: () => {
          if (window.nlcMaps && window.nlcMaps.tabs) {
            window.nlcMaps.tabs.updateSelectionPanel();
          }
        },
      },
      {
        target: '.js-nlc-maps-delete-polygon-btn',
        title: 'Zmazať polygón',
        text:
          'Týmto tlačidlom odstránite aktuálny polygón aj všetky náhľady na mape. To isté urobí klávesa Delete.',
        position: 'bottom',
      },
      {
        target: '.js-nlc-maps-undo-btn',
        title: 'Späť / Dopredu',
        text:
          'Pomýlili ste sa? Vráťte akciu cez tieto tlačidlá alebo klávesovými skratkami Ctrl+Z a Ctrl+Shift+Z.',
        position: 'bottom',
      },
      {
        target: '.js-nlc-maps-order-btn',
        title: 'Objednávka',
        text:
          'Keď máte nakreslený polygón a aspoň jednu zaškrtnutú dlaždicu, toto tlačidlo sa aktivuje a môžete objednávku odoslať.',
        position: 'top',
      },
      {
        target: '.js-nlc-maps-order-btn',
        title: 'Doručenie odkazu na stiahnutie',
        text:
          'Po dokončení objednávky vám odkaz na stiahnutie dát príde na e-mail spravidla do 1–2 hodín. Pri vyššom zaťažení servera môže doručenie trvať až 24 hodín.',
        position: 'top',
      },
    ];

    this.currentStep = 0;
    this.overlay = null;
    this.tooltip = null;
    this.isActive = false;

    this.injectStyles();
    this.addTriggerButton();
  }

  injectStyles() {
    const css = `
      .nlc-walkthrough-overlay {
        position: fixed;
        inset: 0;
        z-index: 99998;
        pointer-events: none;
      }
      .nlc-walkthrough-overlay__backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        pointer-events: auto;
      }
      .nlc-walkthrough-highlight {
        position: fixed;
        z-index: 99999;
        box-shadow: 0 0 0 4px #0065b3, 0 0 0 9999px rgba(0, 0, 0, 0.45);
        border-radius: 6px;
        pointer-events: none;
        transition: all 0.3s ease;
      }
      .nlc-walkthrough-tooltip {
        position: fixed;
        z-index: 100000;
        background: #fff;
        border-radius: 10px;
        padding: 18px 20px;
        max-width: 340px;
        min-width: 280px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
        font-family: Source Sans Pro, Arial, sans-serif;
        pointer-events: auto;
        animation: nlc-wt-fadein 0.25s ease;
      }
      @keyframes nlc-wt-fadein {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
      }
      /* Mobile: tooltip is docked to the bottom of the viewport as a full-width
         card so it never covers the highlighted target — the target scrolls
         into the upper half above the tooltip. */
      @media (max-width: 640px) {
        .nlc-walkthrough-tooltip {
          left: 8px !important;
          right: 8px !important;
          top: auto !important;
          /* env(safe-area-inset-bottom) leaves room for the iOS home indicator
             on notched devices — without it the bottom buttons (Späť, Ďalej)
             can land under the iOS gesture bar and become unclickable. */
          bottom: calc(8px + env(safe-area-inset-bottom, 0px)) !important;
          width: auto;
          max-width: none;
          min-width: 0;
          padding: 14px 16px;
          border-radius: 12px;
          transform: none !important;
          animation: nlc-wt-slideup 0.25s ease;
          /* Cap height at 55 % viewport with internal scroll. Without this a
             step with a long text + buttons could push the footer off the
             bottom of the screen on small phones. */
          max-height: 55vh;
          overflow-y: auto;
          box-sizing: border-box;
        }
        .nlc-walkthrough-tooltip__title { font-size: 15px; margin-bottom: 6px; }
        .nlc-walkthrough-tooltip__text { font-size: 13px; line-height: 1.45; margin-bottom: 12px; }
        .nlc-walkthrough-tooltip__step { font-size: 10px; margin-bottom: 4px; }
        .nlc-walkthrough-tooltip__footer { gap: 6px; flex-wrap: wrap; }
        .nlc-walkthrough-tooltip__btn { padding: 10px 14px; font-size: 13px; min-height: 40px; }
        /* Tighten the highlight ring on mobile so it doesn't visually
           "shout" — a 4px halo around a small icon button looks correct on
           desktop but oversized on phones. */
        .nlc-walkthrough-highlight {
          box-shadow: 0 0 0 3px #0065b3, 0 0 0 9999px rgba(0, 0, 0, 0.55) !important;
        }
      }
      @keyframes nlc-wt-slideup {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .nlc-walkthrough-tooltip__step {
        font-size: 11px;
        font-weight: 600;
        color: #0065b3;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-bottom: 6px;
      }
      .nlc-walkthrough-tooltip__title {
        font-size: 16px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 8px;
      }
      .nlc-walkthrough-tooltip__text {
        font-size: 14px;
        color: #555;
        line-height: 1.5;
        margin-bottom: 18px;
      }
      .nlc-walkthrough-tooltip__footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
      }
      .nlc-walkthrough-tooltip__btn {
        padding: 7px 16px;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        font-family: inherit;
        transition: all 0.15s;
      }
      .nlc-walkthrough-tooltip__btn--primary {
        background: #0065b3;
        color: #fff;
      }
      .nlc-walkthrough-tooltip__btn--primary:hover {
        background: #004d8a;
      }
      .nlc-walkthrough-tooltip__btn--secondary {
        background: #f0f0f0;
        color: #555;
      }
      .nlc-walkthrough-tooltip__btn--secondary:hover {
        background: #e0e0e0;
      }
      .nlc-walkthrough-tooltip__btn--skip {
        background: none;
        color: #999;
        padding: 7px 8px;
      }
      .nlc-walkthrough-tooltip__btn--skip:hover {
        color: #555;
      }
      .nlc-walkthrough-trigger {
        display: flex;
        align-items: center;
        gap: 6px;
        background: transparent !important;
        border: 1px solid #ddd !important;
        border-radius: 5px !important;
        padding: 6px 10px !important;
        cursor: pointer;
        font-family: Source Sans Pro, Arial, sans-serif;
        font-size: 12px;
        color: #666 !important;
        transition: all 0.15s;
      }
      .nlc-walkthrough-trigger:hover,
      .nlc-walkthrough-trigger:focus {
        background: transparent !important;
        border-color: #0065b3 !important;
        color: #0065b3 !important;
        outline: none !important;
        text-decoration: none !important;
      }
      .nlc-walkthrough-trigger svg {
        flex-shrink: 0;
      }
      /* Walkthrough tooltip footer buttons can also get hijacked by host themes */
      .nlc-walkthrough-tooltip__btn--primary,
      .nlc-walkthrough-tooltip__btn--primary:hover,
      .nlc-walkthrough-tooltip__btn--primary:focus {
        background: #0065b3 !important;
        color: #fff !important;
        border: none !important;
        outline: none !important;
      }
      .nlc-walkthrough-tooltip__btn--primary:hover {
        background: #004d8a !important;
      }
      .nlc-walkthrough-tooltip__btn--secondary,
      .nlc-walkthrough-tooltip__btn--secondary:hover,
      .nlc-walkthrough-tooltip__btn--secondary:focus {
        background: #f0f0f0 !important;
        color: #555 !important;
        border: none !important;
        outline: none !important;
      }
      .nlc-walkthrough-tooltip__btn--secondary:hover {
        background: #e0e0e0 !important;
      }
      .nlc-walkthrough-tooltip__btn--skip,
      .nlc-walkthrough-tooltip__btn--skip:hover,
      .nlc-walkthrough-tooltip__btn--skip:focus {
        background: none !important;
        color: #999 !important;
        border: none !important;
        outline: none !important;
      }
      .nlc-walkthrough-tooltip__btn--skip:hover {
        color: #555 !important;
      }
    `;
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  addTriggerButton() {
    const btn = document.createElement('button');
    btn.className = 'nlc-walkthrough-trigger';
    btn.innerHTML = `
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      Potrebujete pomôcť?
    `;
    btn.addEventListener('click', () => this.showWelcome());

    // Insert into sidebar, below order button
    const orderSection = document.querySelector('.nlc-maps__order-map');
    if (orderSection) {
      orderSection.appendChild(btn);
    } else {
      document.querySelector('.js-nlc-maps-container').appendChild(btn);
    }

    // Auto-start on first visit
    if (!localStorage.getItem('nlc-walkthrough-seen')) {
      setTimeout(() => this.showWelcome(), 2000);
      localStorage.setItem('nlc-walkthrough-seen', '1');
    }
  }

  showWelcome() {
    if (this.isActive) return;
    this.isActive = true;
    this.cleanup();

    const highlight = document.createElement('div');
    highlight.className = 'nlc-walkthrough-highlight';
    highlight.style.left = '0px';
    highlight.style.top = '0px';
    highlight.style.width = '0px';
    highlight.style.height = '0px';
    highlight.style.boxShadow = '0 0 0 9999px rgba(0, 0, 0, 0.5)';
    document.body.appendChild(highlight);
    this.highlight = highlight;

    const tooltip = document.createElement('div');
    tooltip.className = 'nlc-walkthrough-tooltip';
    tooltip.style.position = 'fixed';
    tooltip.style.left = '50%';
    tooltip.style.top = '50%';
    tooltip.style.transform = 'translate(-50%, -50%)';
    tooltip.style.maxWidth = '400px';
    tooltip.innerHTML = `
      <div class="nlc-walkthrough-tooltip__title" style="font-size: 20px; text-align: center; margin-bottom: 12px;">Vitajte v LDPZ Portáli</div>
      <div class="nlc-walkthrough-tooltip__text" style="text-align: center;">Chcete si prejsť krátkym sprievodcom? Ukáže vám ako nakresliť polygón a objednať si presne tie mapové dáta, ktoré potrebujete.</div>
      <div class="nlc-walkthrough-tooltip__footer" style="justify-content: center;">
        <button type="button" class="nlc-walkthrough-tooltip__btn nlc-walkthrough-tooltip__btn--secondary js-wt-skip">Preskočiť</button>
        <button type="button" class="nlc-walkthrough-tooltip__btn nlc-walkthrough-tooltip__btn--primary js-wt-start">Spustiť sprievodcu</button>
      </div>
    `;
    document.body.appendChild(tooltip);
    this.tooltip = tooltip;

    tooltip.querySelector('.js-wt-start').addEventListener('click', () => {
      this.start();
    });
    tooltip.querySelector('.js-wt-skip').addEventListener('click', () => {
      this.finish();
    });

    this.escHandler = (e) => {
      if (e.key === 'Escape') this.finish();
    };
    document.addEventListener('keydown', this.escHandler);
  }

  start() {
    this.currentStep = 0;
    this.showStep();
  }

  showStep() {
    this.cleanup();

    if (this.currentStep >= this.steps.length) {
      this.finish();
      return;
    }

    const step = this.steps[this.currentStep];

    if (step.beforeShow) {
      step.beforeShow();
    }

    const afterReady = () => {
      const target = document.querySelector(step.target);

      if (!target) {
        this.skipStep();
        return;
      }

      const rect = target.getBoundingClientRect();
      // Skip hidden / zero-size targets — e.g. search input before tiles are loaded,
      // or group checkboxes before the user has drawn a polygon.
      if (rect.width === 0 && rect.height === 0) {
        this.skipStep();
        return;
      }

      // On mobile we need the target *above* the bottom-docked tooltip. The
      // built-in `scrollIntoView({ block: 'start' })` lands the target flush
      // at the viewport top — too high (browser chrome eats it on iOS Safari)
      // and far from the tooltip which is at the bottom. Scroll manually so
      // the target sits at ~25 % from the top: visible, near the user's gaze,
      // and well clear of the tooltip card.
      const isMobile = window.innerWidth <= 640;
      if (isMobile) {
        const rectNow = target.getBoundingClientRect();
        const desiredTop = window.innerHeight * 0.25;
        const scrollY = window.scrollY + rectNow.top - desiredTop;
        window.scrollTo({ top: Math.max(0, scrollY), behavior: 'smooth' });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      // Wait for the scroll to actually settle before painting the highlight —
      // a fixed 350 ms timeout was too short on slower devices and produced a
      // highlight ring offset by 20-80 px from the target. Instead poll the
      // target's getBoundingClientRect() until it stops moving (or 800 ms
      // hard cap), then draw the overlay against the final position.
      this._waitForScrollSettle(target, () => this.createOverlay(target, step));
    };

    if (step.waitFor) {
      const startTime = Date.now();
      const timeout = step.waitTimeout || 3000;
      const poll = () => {
        if (document.querySelector(step.waitFor)) {
          setTimeout(afterReady, 200);
        } else if (Date.now() - startTime < timeout) {
          setTimeout(poll, 200);
        } else {
          this.skipStep();
        }
      };
      setTimeout(poll, step.beforeShow ? 500 : 0);
    } else {
      setTimeout(afterReady, step.beforeShow ? 500 : 0);
    }
  }

  skipStep() {
    this.currentStep++;
    if (this.currentStep < this.steps.length) {
      this.showStep();
    } else {
      this.finish();
    }
  }

  // Resolve once the target's viewport rect stops changing — i.e. the smooth
  // scroll triggered by showStep() has settled. Falls back to a hard 800 ms
  // cap so we never block indefinitely if the target keeps moving (animated
  // sidebar, lazy-loaded content, …).
  _waitForScrollSettle(target, done) {
    const start = performance.now();
    let prevTop = null;
    let stableFrames = 0;
    const tick = () => {
      const rect = target.getBoundingClientRect();
      if (prevTop !== null && Math.abs(rect.top - prevTop) < 0.5) {
        stableFrames++;
      } else {
        stableFrames = 0;
      }
      prevTop = rect.top;
      // Two consecutive frames at the same position → scroll settled.
      if (stableFrames >= 2 || performance.now() - start > 800) {
        done();
        return;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // Re-snap the highlight ring (and tooltip on desktop) to the target's
  // current rect. Used on resize / orientation change so a phone rotated
  // mid-step doesn't leave the highlight stranded at the old coordinates.
  _repositionForCurrentStep() {
    if (!this.isActive || !this.highlight) return;
    const step = this.steps[this.currentStep];
    if (!step) return;
    const target = document.querySelector(step.target);
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const clamped = this._clampRectToViewport(rect);
    this.highlight.style.left = (clamped.left - 4) + 'px';
    this.highlight.style.top = (clamped.top - 4) + 'px';
    this.highlight.style.width = (clamped.width + 8) + 'px';
    this.highlight.style.height = (clamped.height + 8) + 'px';
    if (this.tooltip && window.innerWidth > 640) {
      this.positionTooltip(this.tooltip, rect, step.position);
    }
  }

  // Clip a target rect to the viewport's "safe zone" — the area NOT covered by
  // the bottom-docked tooltip (mobile) or by viewport edges (any size). For a
  // step like "Dlaždice pre vašu oblasť" the target is the whole left sidebar
  // — its rect can extend a few hundred pixels below the visible area on a
  // small phone. If we draw the highlight ring around the raw rect, the user
  // sees only the top edge of a frame that disappears off the bottom of the
  // screen behind the tooltip. Clamping keeps the highlight always fully
  // visible while still pointing at the right region.
  _clampRectToViewport(rect) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    // Estimate how much vertical space the bottom-docked mobile tooltip eats.
    // The CSS caps it at 55vh + a bottom margin including safe-area-inset.
    let bottomReserved = 0;
    if (vw <= 640) {
      bottomReserved = this.tooltip
        ? this.tooltip.getBoundingClientRect().height + 16
        : Math.round(vh * 0.45); // worst-case estimate before tooltip exists
    }
    const safeLeft = 4;
    const safeRight = vw - 4;
    const safeTop = 4;
    const safeBottom = vh - bottomReserved - 4;

    const left = Math.max(rect.left, safeLeft);
    const top = Math.max(rect.top, safeTop);
    const right = Math.min(rect.right, safeRight);
    const bottom = Math.min(rect.bottom, safeBottom);

    return {
      left,
      top,
      width: Math.max(20, right - left),
      height: Math.max(20, bottom - top),
    };
  }

  createOverlay(target, step) {
    const rect = target.getBoundingClientRect();

    const highlight = document.createElement('div');
    highlight.className = 'nlc-walkthrough-highlight';
    const clamped = this._clampRectToViewport(rect);
    highlight.style.left = (clamped.left - 4) + 'px';
    highlight.style.top = (clamped.top - 4) + 'px';
    highlight.style.width = (clamped.width + 8) + 'px';
    highlight.style.height = (clamped.height + 8) + 'px';
    document.body.appendChild(highlight);
    this.highlight = highlight;

    const tooltip = document.createElement('div');
    tooltip.className = 'nlc-walkthrough-tooltip';
    // Hide until positioning is computed — otherwise the tooltip flashes
    // at the browser-default (0,0 / bottom-corner) position before
    // positionTooltip moves it. Hidden visibility still allows measurement.
    tooltip.style.visibility = 'hidden';

    const isFirst = this.currentStep === 0;
    const isLast = this.currentStep === this.steps.length - 1;

    tooltip.innerHTML = `
      <div class="nlc-walkthrough-tooltip__step">Krok ${this.currentStep + 1} z ${this.steps.length}</div>
      <div class="nlc-walkthrough-tooltip__title">${step.title}</div>
      <div class="nlc-walkthrough-tooltip__text">${step.text}</div>
      <div class="nlc-walkthrough-tooltip__footer">
        <div class="nlc-walkthrough-tooltip__buttons">
          <button type="button" class="nlc-walkthrough-tooltip__btn nlc-walkthrough-tooltip__btn--skip js-wt-skip">Preskočiť</button>
          ${!isFirst ? '<button type="button" class="nlc-walkthrough-tooltip__btn nlc-walkthrough-tooltip__btn--secondary js-wt-prev">Späť</button>' : ''}
          <button type="button" class="nlc-walkthrough-tooltip__btn nlc-walkthrough-tooltip__btn--primary js-wt-next">${isLast ? 'Dokončiť' : 'Ďalej'}</button>
        </div>
      </div>
    `;

    document.body.appendChild(tooltip);
    this.tooltip = tooltip;

    this.positionTooltip(tooltip, rect, step.position);
    // Reveal now that the tooltip is at its final coordinates — the fadein
    // animation runs in place instead of from a stale browser-default spot.
    tooltip.style.visibility = '';

    // Re-clamp the highlight now that we know the tooltip's real height. The
    // initial pass used a worst-case 45 vh estimate; once the tooltip is in
    // the DOM we can shrink the reserved bottom band to its actual size,
    // giving the highlight more room when the step text is short.
    this._repositionForCurrentStep();

    tooltip.querySelector('.js-wt-next').addEventListener('click', () => {
      this.currentStep++;
      this.showStep();
    });

    const prevBtn = tooltip.querySelector('.js-wt-prev');
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        this.currentStep--;
        this.showStep();
      });
    }

    tooltip.querySelector('.js-wt-skip').addEventListener('click', () => {
      this.finish();
    });

    this.escHandler = (e) => {
      if (e.key === 'Escape') this.finish();
    };
    document.addEventListener('keydown', this.escHandler);

    // Keep highlight + tooltip aligned with the target across viewport
    // changes — phone rotation, address-bar collapse on iOS Safari, mobile
    // keyboard popup, sidebar re-layout. Debounced via rAF so a continuous
    // resize stream doesn't spam getBoundingClientRect.
    if (!this.resizeHandler) {
      let raf = 0;
      this.resizeHandler = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this._repositionForCurrentStep());
      };
      window.addEventListener('resize', this.resizeHandler);
      window.addEventListener('orientationchange', this.resizeHandler);
    }
  }

  positionTooltip(tooltip, targetRect, preferredPosition) {
    // Mobile: tooltip is docked to the bottom via CSS — leave it alone here
    // so JS doesn't override the responsive layout.
    if (window.innerWidth <= 640) return;

    const gap = 14;
    const margin = 12;

    tooltip.style.left = '0px';
    tooltip.style.top = '0px';
    const tooltipRect = tooltip.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    const positions = [preferredPosition, 'bottom', 'top', 'right', 'left'];
    let left, top;

    for (const pos of positions) {
      switch (pos) {
        case 'bottom':
          left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
          top = targetRect.bottom + gap;
          break;
        case 'top':
          left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
          top = targetRect.top - tooltipRect.height - gap;
          break;
        case 'right':
          left = targetRect.right + gap;
          top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
          break;
        case 'left':
          left = targetRect.left - tooltipRect.width - gap;
          top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
          break;
      }

      if (left >= margin && left + tooltipRect.width <= vw - margin &&
          top >= margin && top + tooltipRect.height <= vh - margin) {
        break;
      }
    }

    left = Math.max(margin, Math.min(left, vw - tooltipRect.width - margin));
    top = Math.max(margin, Math.min(top, vh - tooltipRect.height - margin));

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  cleanup() {
    if (this.highlight) {
      this.highlight.remove();
      this.highlight = null;
    }
    if (this.tooltip) {
      this.tooltip.remove();
      this.tooltip = null;
    }
    if (this.escHandler) {
      document.removeEventListener('keydown', this.escHandler);
      this.escHandler = null;
    }
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      window.removeEventListener('orientationchange', this.resizeHandler);
      this.resizeHandler = null;
    }
  }

  finish() {
    this.cleanup();
    this.isActive = false;
    this.showFinishDialog();
  }

  showFinishDialog() {
    const highlight = document.createElement('div');
    highlight.className = 'nlc-walkthrough-highlight';
    highlight.style.left = '0px';
    highlight.style.top = '0px';
    highlight.style.width = '0px';
    highlight.style.height = '0px';
    highlight.style.boxShadow = '0 0 0 9999px rgba(0, 0, 0, 0.5)';
    document.body.appendChild(highlight);
    this.highlight = highlight;

    const tooltip = document.createElement('div');
    tooltip.className = 'nlc-walkthrough-tooltip';
    tooltip.style.position = 'fixed';
    tooltip.style.left = '50%';
    tooltip.style.top = '50%';
    tooltip.style.transform = 'translate(-50%, -50%)';
    tooltip.style.maxWidth = '400px';
    tooltip.style.textAlign = 'center';
    tooltip.innerHTML = `
      <div class="nlc-walkthrough-tooltip__title" style="font-size: 20px; margin-bottom: 12px;">To je všetko!</div>
      <div class="nlc-walkthrough-tooltip__text">
        Ak budete potrebovať pomoc, kliknite na „Potrebujete pomôcť?" pod tlačidlom objednávky.
      </div>
      <div class="nlc-walkthrough-tooltip__footer" style="justify-content: center;">
        <button type="button" class="nlc-walkthrough-tooltip__btn nlc-walkthrough-tooltip__btn--primary js-wt-close">Rozumiem</button>
      </div>
    `;
    document.body.appendChild(tooltip);
    this.tooltip = tooltip;

    tooltip.querySelector('.js-wt-close').addEventListener('click', () => {
      this.cleanup();
      this.isActive = false;
    });

    this.escHandler = (e) => {
      if (e.key === 'Escape') {
        this.cleanup();
        this.isActive = false;
      }
    };
    document.addEventListener('keydown', this.escHandler);
  }
}

export default Walkthrough;
